import React, { isValidElement } from "react";
import { addProps } from "shared/src/utils/addProps";
import { Image } from "components/src/components/Image/Image";

export const parseImage = (image, props) => {
  const hasImage = !!image;
  if (hasImage && typeof image === "string")
    return <Image name={image} {...props} />;
  if (hasImage && typeof image === "object" && !("type" in image))
    return <Image {...props} {...image} />;
  if (hasImage && "type" in image && image.type?.isImageType) {
    return addProps(image, props);
  }
  if (isValidElement(image)) {
    return image;
  }
  return null;
};
